export function announceClock(messages: readonly string[]): void {
  speak(messages, 1.3);
}

export function announceHomeworkCountdown(second: number): void {
  if (!Number.isInteger(second) || second < 0 || second > 10) return;
  speak([String(second)], 1.65);
}

function speak(messages: readonly string[], rate: number): void {
  if (
    messages.length === 0 ||
    typeof window.speechSynthesis === 'undefined' ||
    typeof window.SpeechSynthesisUtterance === 'undefined'
  ) {
    return;
  }

  try {
    const synthesizer = window.speechSynthesis;
    synthesizer.cancel();
    if (synthesizer.paused) synthesizer.resume();
    const utterance = new window.SpeechSynthesisUtterance(messages.join('，'));
    utterance.lang = 'zh-CN';
    utterance.rate = rate;
    utterance.pitch = 1;
    synthesizer.speak(utterance);
  } catch {
    // Voice support is optional and must never interrupt the authoritative game UI.
  }
}

export function cancelClockAnnouncements(): void {
  try {
    if (typeof window.speechSynthesis !== 'undefined') window.speechSynthesis.cancel();
  } catch {
    // Some embedded browsers expose an incomplete speech API; leaving the page must remain safe.
  }
}
